"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.stat.scheduled': 'Zaplanowane',
    'socialMediaPlan.stat.drafts': 'Szkice i do akceptacji',
    'socialMediaPlan.stat.published': 'Opublikowane',
    'socialMediaPlan.stat.total': 'Łącznie postów',
};
